import React from 'react';

import { KaasContextProps } from './types';

const KaasContext = React.createContext<KaasContextProps | undefined>(undefined);

export default KaasContext;
